module.exports = __webpack_public_path__ + "static/media/img_8.d5f810a8.png";